import { render, staticRenderFns } from "./igt-tabs.vue?vue&type=template&id=56edb4ae&scoped=true&"
import script from "./igt-tabs.vue?vue&type=script&lang=js&"
export * from "./igt-tabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56edb4ae",
  null
  
)

export default component.exports